import { createConfig } from '@/utils/plugins/config';

if (process.env.NODE_ENV === 'production' || window.localStorage.getItem('__odr-dev-widget')) {
    let config = createConfig(window.OA.length ? window.OA[0] : window.OA, 0);
    // eslint-disable-next-line no-undef, @typescript-eslint/camelcase
    __webpack_public_path__ = config.staticUrl + '/';
}
